module.exports = __webpack_public_path__ + "static/media/cockpit_icon3.356213de.svg";